import { CustomSVGProps } from './CustomSVGProps.types';
export function IconTiktok24(props: CustomSVGProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={!props.onClick}
            aria-label="tiktok"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4828 6.4598V16.7586C14.4828 20.2056 11.6884 23 8.24138 23C4.79436 23 2 20.2056 2 16.7586V16.5806C2 13.0353 4.87404 10.1613 8.41935 10.1613H9.55172V12.1613H8.41935C5.97861 12.1613 4 14.1399 4 16.5806V16.7586C4 19.1011 5.89893 21 8.24138 21C10.5838 21 12.4828 19.1011 12.4828 16.7586V1H14.4828C14.4828 4.56313 17.3712 7.45161 20.9344 7.45161H22V9.45161H20.9344C18.348 9.45161 16.0331 8.28989 14.4828 6.4598Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconTiktok48(props: CustomSVGProps) {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="tiktok">
            <path
                d="M20.5358 21.279C17.1278 20.4521 8.77507 20.6953 8.02283 30.9099C7.7685 34.3634 9.52675 42 19.0098 42C22.6577 42 29.7526 39.6652 29.9968 32.0773V18.9442C31.421 20.3061 35.2156 22.8549 39 22.1545V16.9013C36.2533 16.6581 30.6072 14.5373 29.9968 8H24.3507V32.0773C24.3507 33.6824 23.4131 36.8927 19.0098 36.8927C16.9695 36.8927 12.5024 34.9957 13.1128 30.9099C13.1128 28.3562 16.7514 24.9854 20.5358 26.97V21.279Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
